module.exports = __webpack_public_path__ + "static/game-davosklosters-abinsbaumhaus-fd54815d225eb59e409b9a1a0d18c58a.png";